import { Link } from "react-router-dom";
import "./Card.css";

const Card = ({ img, title, id }) => {
  return (
    <Link to={`/project/${id}`} className="project-card">
      <img src={img} alt={title} />
      <h4>{title}</h4>
      <button>Know More</button>
    </Link>
  );
};

export default Card;
